import styled, { keyframes } from 'styled-components'
import { fadeIn } from 'react-animations'

const animation = keyframes`${fadeIn}`

export const StepsAnimationWrapper = styled.div`
	animation: 1.5s ${animation};
`
